class MultiHashMap {
    constructor() {
        this.map = {};
    }

    add(key, value) {
        if (!this.map[key]) {
            this.map[key] = [];
        }
        this.map[key].push(value);
    }

    get(key) {
        return this.map[key] || [];
    }

    remove(key, value) {
        if (this.map[key]) {
            const index = this.map[key].indexOf(value);
            if (index !== -1) {
                this.map[key].splice(index, 1);
                if (this.map[key].length === 0) {
                    delete this.map[key];
                }
            }
        }
    }

    removeAll(key) {
        delete this.map[key];
    }

    hasKey(key) {
        return this.map.hasOwnProperty(key);
    }

    getKeys() {
        return Object.keys(this.map);
    }
}

export default MultiHashMap;
